import { configureStore } from "@reduxjs/toolkit";
import { Counterslice } from "../feature/product";
import cartReducer  from '../feature/cartSlice'
import wishlistReducer from "../feature/wishlist";

 export const store = configureStore(
    {
        reducer:{
            counter:Counterslice.reducer,
               cart: cartReducer,
               wishlist: wishlistReducer, 
        }
    }
);

store.subscribe(() => {
 const state = store.getState();
  localStorage.setItem("cart", JSON.stringify(state.cart.items));
  localStorage.setItem("wishlist", JSON.stringify(state.wishlist.items));
});